const Page = () =>
  import(
    /* webpackChunkName: "site-generator-cms-page" */ '@/pages/site-generator/cms/page/index.vue'
  )
const CreatePage = () =>
  import(
    /* webpackChunkName: "site-generator-cms-page" */ '@/pages/site-generator/cms/page/create.vue'
  )
const EditPage = () =>
  import(
    /* webpackChunkName: "site-generator-cms-page" */ '@/pages/site-generator/cms/page/edit.vue'
  )

export default {
  path: 'page',
  meta: {
    label: 'page',
    auth: 'page'
  },
  component: {
    name: 'Page',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'SitePageReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Page
    },
    {
      name: 'SiteCreatePage',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreatePage
    },
    {
      name: 'SiteEditPage',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditPage,
      props: true
    }
  ]
}
